// extracted by mini-css-extract-plugin
export default {"tag":"PaymentRequestStatusTag-module__tag--lAkcg","large":"PaymentRequestStatusTag-module__large--gnQM8","status":"PaymentRequestStatusTag-module__status--QsCyB"};